import { render } from "./VoiceGuide.vue?vue&type=template&id=3206b3a0&scoped=true"
import script from "./VoiceGuide.vue?vue&type=script&lang=js"
export * from "./VoiceGuide.vue?vue&type=script&lang=js"

import "./VoiceGuide.vue?vue&type=style&index=0&id=3206b3a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3206b3a0"]])

export default __exports__